import React from 'react';

import './headerStyles.scss';

const HeaderPlaceholder = () => (
  <header className="nx-global-header">
    <div className="nx-global-header__wrapper">
      <div className="nx-global-header-app">
        <svg
          className="nx-svg-icon nx-global-header-app__icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 23.99"
          style={{ fill: 'rgb(49, 67, 88)' }}
        >
          <path d="M0 21.17a2.82 2.82 0 0 1 2.82-2.82h.36l4-9.06A2.82 2.82 0 1 1 11 9l3.21 5.08A2.82 2.82 0 0 1 15.4 14l4-9.07a2.81 2.81 0 1 1 1.41.65l-3.93 9a2.82 2.82 0 1 1-3.88.36L9.73 9.85a2.82 2.82 0 0 1-1.17.09l-4 9A2.82 2.82 0 1 1 0 21.17zm1.55 0a1.27 1.27 0 1 0 1.27-1.27 1.27 1.27 0 0 0-1.27 1.27zm12.26-4.37a1.26 1.26 0 1 0 .37-.9 1.27 1.27 0 0 0-.37.9zM7.67 7.14a1.27 1.27 0 1 0 1.27-1.27 1.27 1.27 0 0 0-1.27 1.27zm12.26-4.35a1.27 1.27 0 1 0 1.27-1.26 1.27 1.27 0 0 0-1.27 1.26z" />
        </svg>
        <div className="nx-global-header-app__name">Communication Insights</div>
      </div>
      <div className="nx-global-header-buttons">
        <div className="nx-popover-target nx-popover-click-outside-ignore9">
          <div>
            <a
              className="nx-global-header-button"
              aria-label="Calendar"
              href="/apps/calendar"
            >
              <div className="nx-global-header-icon">
                <div className="nx-global-header-icon__icon">
                  <svg
                    className="nx-svg-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 18"
                    style={{ fill: 'rgb(204, 204, 204)' }}
                  >
                    <path d="M15.3 1.75h-1.24V.62a.64.64 0 0 0-.67-.62.62.62 0 0 0-.62.62v1.13H5.23V.62A.62.62 0 0 0 4.61 0 .59.59 0 0 0 4 .62v1.13H2.7A2.7 2.7 0 0 0 0 4.44V15.3A2.66 2.66 0 0 0 2.7 18h12.6a2.7 2.7 0 0 0 2.7-2.7V4.44a2.7 2.7 0 0 0-2.7-2.69zm1.46 13.55a1.45 1.45 0 0 1-1.46 1.46H2.7a1.45 1.45 0 0 1-1.46-1.46V4.44A1.45 1.45 0 0 1 2.7 3H4v.56a.62.62 0 0 0 1.24 0V3h7.54v.56a.62.62 0 0 0 .62.62.58.58 0 0 0 .67-.62V3h1.29a1.45 1.45 0 0 1 1.46 1.46V15.3zM5.63 9.56H4.5A.53.53 0 0 1 3.94 9V7.88a.53.53 0 0 1 .56-.56h1.13a.53.53 0 0 1 .56.56V9a.56.56 0 0 1-.56.56zm4 0H8.49A.53.53 0 0 1 7.93 9V7.88a.53.53 0 0 1 .56-.56h1.13a.53.53 0 0 1 .56.56V9a.56.56 0 0 1-.56.56zm3.94 0h-1.14a.53.53 0 0 1-.56-.56V7.88a.53.53 0 0 1 .56-.56h1.12a.53.53 0 0 1 .56.56V9a.56.56 0 0 1-.56.56zM5.63 13.5H4.5a.53.53 0 0 1-.56-.56v-1.13a.53.53 0 0 1 .56-.56h1.13a.53.53 0 0 1 .56.56v1.12a.56.56 0 0 1-.56.57zm4 0H8.49a.53.53 0 0 1-.56-.56v-1.13a.53.53 0 0 1 .56-.56h1.13a.53.53 0 0 1 .56.56v1.12a.56.56 0 0 1-.56.57zm3.94 0h-1.14a.53.53 0 0 1-.56-.56v-1.13a.53.53 0 0 1 .56-.56h1.12a.53.53 0 0 1 .56.56v1.12a.56.56 0 0 1-.56.56z" />
                  </svg>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="nx-popover-target nx-popover-click-outside-ignore7">
          <div>
            <a className="nx-global-header-button" aria-label="Chat">
              <div className="nx-global-header-icon">
                <div className="nx-global-header-icon__icon">
                  <svg
                    className="nx-svg-icon chat-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 18.61"
                    style={{ fill: 'rgb(204, 204, 204)' }}
                  >
                    <path d="M6.1 16.28v-1.14A7.65 7.65 0 0 1 7.66 0h8.47a7.66 7.66 0 1 1 0 15.3h-2.38l-5.5 2.39-2.15.92zM1.54 7.66a6.09 6.09 0 0 0 6.09 6.12v2.5l5.79-2.5h2.71a6.12 6.12 0 1 0 0-12.23H7.66a6.12 6.12 0 0 0-6.12 6.11zm6.28 3a.76.76 0 0 1-.76-.76.78.78 0 0 1 .76-.76H16a.76.76 0 1 1 0 1.51zm0-4.25a.76.76 0 0 1-.76-.76.78.78 0 0 1 .76-.76H16a.76.76 0 1 1 0 1.51z" />
                  </svg>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="nx-popover-target nx-popover-click-outside-ignore4">
          <div>
            <a className="nx-global-header-button" aria-label="Contact Support">
              <div className="nx-global-header-icon">
                <div className="nx-popover-target nx-popover-click-outside-ignore5">
                  <div className="nx-global-header-icon__icon">
                    <svg
                      className="nx-svg-icon"
                      width="18"
                      height="18"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: 'rgb(204, 204, 204)' }}
                    >
                      <path d="M9 17c4.42 0 8-3.58 8-8a8 8 0 1 0-8 8m0 1A9 9 0 1 1 9.001-.001 9 9 0 0 1 9 18m.01-4c-.27 0-.506-.088-.708-.264C8.1 13.56 8 13.314 8 12.998c0-.282.097-.517.292-.71A.985.985 0 0 1 9.01 12c.28 0 .514.096.704.287a.97.97 0 0 1 .286.71c0 .312-.1.557-.3.736a1 1 0 0 1-.69.267M6 6.604c0-.395.123-.794.367-1.2.244-.404.6-.74 1.067-1.005C7.902 4.132 8.448 4 9.073 4c.58 0 1.091.111 1.536.333.443.222.786.525 1.028.907.242.381.363.797.363 1.246 0 .352-.069.661-.206.927-.14.266-.303.496-.493.688-.19.193-.53.518-1.022.975a4.23 4.23 0 0 0-.328.34 1.255 1.255 0 0 0-.276.511c-.021.08-.054.222-.099.425-.076.432-.314.648-.714.648a.713.713 0 0 1-.525-.211c-.14-.141-.212-.35-.212-.63 0-.348.051-.65.156-.906.104-.255.242-.48.414-.673.172-.192.403-.421.695-.687.256-.233.442-.408.555-.526.114-.119.21-.25.288-.395a1.119 1.119 0 0 0-.24-1.314c-.237-.229-.544-.344-.92-.344-.44 0-.765.116-.973.345-.208.232-.384.57-.527 1.02-.136.468-.395.703-.775.703a.746.746 0 0 1-.566-.246A.761.761 0 0 1 6 6.604" />
                    </svg>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="nx-popover-target nx-popover-click-outside-ignore10">
          <div>
            <a
              className="nx-global-header-button"
              aria-label="Administration Tools"
            >
              <div className="nx-global-header-icon nx-global-header-admin-tools">
                <div className="nx-global-header-icon__icon">
                  <svg
                    className="nx-svg-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18 17.97"
                    style={{ fill: 'rgb(204, 204, 204)' }}
                  >
                    <path d="M17.47 3.25c-.3.34-.81.78-1.54 1.44a1.77 1.77 0 0 1-2.62 0 1.77 1.77 0 0 1 0-2.62C14 1.36 14.78.53 14.77.52a5.56 5.56 0 0 0-7.62 6.82L.61 13.88a2.47 2.47 0 0 0 3.5 3.48l6.55-6.5a5.59 5.59 0 0 0 5.72-1.34 5.53 5.53 0 0 0 1.09-6.27zm-2 5.37a4.33 4.33 0 0 1-5.11.74l-7.12 7.13a1.241 1.241 0 0 1-1.76-1.75l7.15-7.13a4.27 4.27 0 0 1 3.73-6.34 3.083 3.083 0 1 0 4.37 4.35 4.26 4.26 0 0 1-1.23 3z" />
                    <path d="M17.47 3.25c-.3.34-.81.78-1.54 1.44a1.77 1.77 0 0 1-2.62 0 1.77 1.77 0 0 1 0-2.62C14 1.36 14.78.53 14.77.52a5.56 5.56 0 0 0-7.62 6.82L.61 13.88a2.47 2.47 0 0 0 3.5 3.48l6.55-6.5a5.59 5.59 0 0 0 5.72-1.34 5.53 5.53 0 0 0 1.09-6.27zm-2 5.37a4.33 4.33 0 0 1-5.11.74l-7.12 7.13a1.241 1.241 0 0 1-1.76-1.75l7.15-7.13a4.27 4.27 0 0 1 3.73-6.34 3.083 3.083 0 1 0 4.37 4.35 4.26 4.26 0 0 1-1.23 3z" />
                  </svg>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="nx-current-user-button">
          <div className="nx-popover-target nx-popover-click-outside-ignore6">
            <div className="nx-current-user-button__initials">A</div>
          </div>
        </div>
      </div>
    </div>
  </header>
);

export { HeaderPlaceholder as Header };
